<template>
  <div>
    <div>
      <button
        class="btn"
        @click="createCampaign()"
        style="background-color: #0051a9; color: #fff; font-size: 0.8rem"
      >
        Criar nova campanha
      </button>
    </div>
    <div
      style="
        margin-top: 20px;
        display: flex;
        background-color: #6767670f;
        padding: 10px;
        border-radius: 5px;
        justify-content: space-between;
      "
      v-for="(item, index) in data"
      :key="index"
    >
      <div style="display: flex; gap: 40px; font-size: 0.8rem">
        <div
          class="d-flex justify-content-center align-items-center"
          style="gap: 10px"
        >
          <b>Campanha:</b>
          <p style="font-size: 0.8rem">{{ item.name }}</p>
        </div>
        <div
          class="d-flex justify-content-center align-items-center"
          style="gap: 10px"
        >
          <b>Data de envio:</b>
          <p style="font-size: 0.8rem">{{ item.data }} {{ item.hour }}</p>
        </div>
        <div
          class="d-flex justify-content-center align-items-center"
          style="gap: 10px"
        >
          <b>N Contatos:</b>
          <p style="font-size: 0.8rem">{{ item.contacts.length }}</p>
        </div>
        <div
          class="d-flex justify-content-center align-items-center"
          style="gap: 10px"
        >
          <b>Status:</b>
          <p style="font-size: 0.8rem">{{ item.status }}</p>
        </div>
      </div>
      <div style="display: flex; gap: 20px">
        <b-button
          size="sm"
          variant="light"
          style="color: black"
          @click="duplicated(item)"
          v-b-popover.hover.top="{
            variant: 'secondary',
            content: 'Duplicar',
          }"
        >
          <b-icon-stickies-fill scale="0.7" />
        </b-button>

        <b-button
          size="sm"
          variant="light"
          style="color: black"
          v-b-popover.hover.top="{
            variant: 'secondary',
            content: 'Editar',
          }"
          @click="edit(item.id)"
        >
          <b-icon-pencil-square scale="0.7" />
        </b-button>
        <b-button
          size="sm"
          variant="light"
          style="color: black"
          v-b-popover.hover.top="{
            variant: 'secondary',
            content: 'Excluir',
          }"
          @click="destroy(item.id)"
        >
          <b-icon-trash class="ml-1" scale="0.7" />
        </b-button>
      </div>
    </div>

    <div
      v-if="data.length === 0"
      style="
        height: 300px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <p style="text-align: center; margin-top: 20px; font-size: 1.2rem">
        Nenhuma campanha encontrada
      </p>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import api from "../../../services/axios";

import sweetalert2 from "sweetalert2";

export default {
  props: {
    nextPage: {
      type: Function,
    },
    body: {
      type: Object,
    },
  },

  data() {
    return {
      data: [],
    };
  },
  created() {
    this.list();
  },
  methods: {
    async list() {
      const response = await api.get("/campaigns");

      this.data = response.data.map((e) => {
        return {
          id: e.id,
          name: e.name,
          data: DateTime.fromSQL(e.startDate).toFormat("dd/MM/yyyy"),
          hour: DateTime.fromSQL(e.startDate).toFormat("HH:mm"),
          contacts: e.contacts,
          status: e.status,
        };
      });
    },
    async edit(id) {
      const response = await api.get(`/campaigns/${id}`);

      this.$emit("changeBody", {
        id,
        name: response.data.name,
        message: response.data.description,
        data: DateTime.fromSQL(response.data.startDate).toSQLDate(),
        hour: DateTime.fromSQL(response.data.startDate).toFormat("HH:mm"),
        contacts: response.data.contacts,
        status: response.data.status,
      });

      this.nextPage("previewMarketing");
    },
    async destroy(id) {
      const confirm = await sweetalert2.fire({
        title: "",
        text: "Deseja realmente excluir a campanha?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0051a9",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
      });

      if (confirm.isConfirmed) {
        await api.delete(`/campaigns/${id}`);
        this.list();
      }
    },
    async createCampaign() {
      this.$emit("clearBody");
      this.nextPage("newCampanha");
    },
    async duplicated(item) {
      const response = await api.get(`/campaigns/${item.id}`);
      this.$emit("changeBody", {
        id: null,
        name: response.data.name,
        message: response.data.description,
        data: DateTime.fromSQL(response.data.startDate).toSQLDate(),
        hour: DateTime.fromSQL(response.data.startDate).toFormat("HH:mm"),
        contacts: [],
      });
      this.nextPage("newCampanha");
      this.$toast.open({
        message: "Campanha duplicada com sucesso",
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
p {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
}
</style>